const API_BASE = '/api/vc-usr';

function authHeaders(hasBody) {
  const token = localStorage.getItem('authToken');
  return {
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
    ...(hasBody ? { 'Content-Type': 'application/json' } : {}),
  };
}

async function chatApi(path, { method = 'GET', body } = {}) {
  const res = await fetch(`${API_BASE}${path}`, {
    method,
    headers: authHeaders(body !== undefined),
    ...(body !== undefined ? { body: JSON.stringify(body) } : {}),
  });
  const json = await res.json().catch(() => ({}));
  if (!res.ok || json.success === false) {
    throw new Error(json.message || `Erro ${res.status}`);
  }
  return json;
}

export function fetchChatSettings() {
  return chatApi('/chat-settings');
}

export function fetchChatAgents(clientId) {
  const qs =
    clientId != null && String(clientId).trim() !== ''
      ? `?clientId=${encodeURIComponent(String(clientId).trim())}`
      : '';
  return chatApi(`/chat/agents${qs}`);
}

export function fetchChatEligibleUsers() {
  return chatApi('/chat/agents/eligible-users');
}

export function fetchChatCodtechUsage() {
  return chatApi('/chat/agents/codtech-usage');
}

export function createChatAgent(payload) {
  return chatApi('/chat/agents', { method: 'POST', body: payload });
}

export function updateChatAgentCodtech(agentId, codtech) {
  const idSeg = agentId != null && agentId !== '' ? String(agentId) : '0';
  return chatApi(`/chat/agents/${idSeg}/codtech`, {
    method: 'PATCH',
    body: { codtech: codtech || null },
  });
}

export function deleteChatAgent(agentId, { verveUserId, linkId } = {}) {
  const params = new URLSearchParams();
  if (verveUserId != null && verveUserId !== '') params.set('verveUserId', String(verveUserId));
  if (linkId != null && linkId !== '') params.set('linkId', String(linkId));
  const qs = params.toString();
  const idSeg = agentId != null && agentId !== '' ? String(agentId) : '0';
  return chatApi(`/chat/agents/${idSeg}${qs ? `?${qs}` : ''}`, { method: 'DELETE' });
}

export function fetchChatTeams() {
  return chatApi('/chat/teams');
}

export function fetchChatPreAtendimento() {
  return chatApi('/chat/teams/pre-atendimento');
}

export function updateChatPreAtendimento(teamId) {
  return chatApi('/chat/teams/pre-atendimento', {
    method: 'PATCH',
    body: { teamId },
  });
}

export function createChatTeam(payload) {
  return chatApi('/chat/teams', { method: 'POST', body: payload });
}

export function updateChatTeam(teamId, payload) {
  return chatApi(`/chat/teams/${teamId}`, { method: 'PATCH', body: payload });
}

export function deleteChatTeam(teamId) {
  return chatApi(`/chat/teams/${teamId}`, { method: 'DELETE' });
}

export function assignChatTeamAgents(teamId, agentIds) {
  return chatApi(`/chat/teams/${teamId}/agents`, {
    method: 'POST',
    body: { agentIds },
  });
}

export function fetchChatTeamAgents(teamId) {
  return chatApi(`/chat/teams/${teamId}/agents`);
}

export function fetchChatInbox() {
  return chatApi('/chat/inbox');
}

export function updateChatInbox(payload) {
  return chatApi('/chat/inbox', { method: 'PATCH', body: payload });
}
